import sumBy from "lodash/sumBy";

import { QueryKeys, useEntities } from "@/api/core";
import { useStatContext } from "@/contexts/stat-context";
import { useLoggedIn } from "@/hooks";
import { chatSchema } from "@/schemas";

function useChats() {
  const { setUnreadChatsCount } = useStatContext();
  const { isLoggedIn } = useLoggedIn();

  const queryInfo = useEntities({
    queryKey: QueryKeys.chats.list(),
    enabled: isLoggedIn,
    endpoint: "/api/v1/pleroma/chats",
    keepPreviousData: true,
    schema: chatSchema,
    formatResult(result, response) {
      setUnreadChatsCount(
        Number(response.headers["x-unread-messages-count"]) ||
          sumBy(result, (chat) => chat.unread),
      );

      return result;
    },
    relationshipConfig: {
      category: "account",
      extractIds(result) {
        return result.map((chat) => chat.account.id);
      },
    },
  });

  return {
    ...queryInfo,
    isLoading: queryInfo.isInitialLoading,
  };
}

export { useChats };
